<div class="container">
  <h3 i18n>Leite zu Anhang weiter...</h3>
  <mat-spinner></mat-spinner>
</div>
